import { render, staticRenderFns } from "./diagonal-placeholder.vue?vue&type=template&id=02ad0a3b&scoped=true"
import script from "./diagonal-placeholder.vue?vue&type=script&lang=js"
export * from "./diagonal-placeholder.vue?vue&type=script&lang=js"
import style0 from "./diagonal-placeholder.vue?vue&type=style&index=0&id=02ad0a3b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ad0a3b",
  null
  
)

export default component.exports